import { useMemo, useState } from "react";

import { DriverRouteType } from "@web-app/types";
import { getMetersToMiles } from "@web-app/utils/helpers";

export const useDriverRouteMapState = (
  driverRoute: DriverRouteType | undefined,
) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoveredPoint, setHoveredPoint] = useState<{
    lat: number;
    lng: number;
    timestamp: string;
  } | null>(null);
  const [hoveredEventMarker, setHoveredEventMarker] = useState<{
    bgColor: string;
    color: string;
    lat: number;
    lng: number;
    name: string;
    orderName?: string;
    timestamp: Date;
  } | null>(null);

  const routeCoordinates = useMemo(() => {
    if (!driverRoute) return [];

    return driverRoute.locationEntries.map((entry) => ({
      lat: entry.coordinates.latitude,
      lng: entry.coordinates.longitude,
    }));
  }, [driverRoute]);

  const routePoints = useMemo(() => {
    if (!driverRoute) return [];

    return driverRoute.locationEntries.map((entry) => ({
      lat: entry.coordinates.latitude,
      lng: entry.coordinates.longitude,
      timestamp: entry.timestamp,
    }));
  }, [driverRoute]);

  const actualDistance = useMemo(() => {
    if (!driverRoute) return "0 miles";
    return `${getMetersToMiles(driverRoute.distance)} miles`;
  }, [driverRoute]);

  return {
    actualDistance,
    hoveredEventMarker,
    hoveredPoint,
    isExpanded,
    routeCoordinates,
    routePoints,
    setHoveredEventMarker,
    setHoveredPoint,
    setIsExpanded,
  };
};

export type { EventBase, EventMarker } from "./driverRouteUtils";
